<template>
    <div class="mt-4 row">
        <MbLoading v-if="isLoading"></MbLoading>
        <div v-else class="col-lg-10 mx-auto">
            <div class="col-lg-10 mx-auto text-center mb-5">
                <button v-if="displayNew" @click="onClickNewSession" class="btn btn-secondary me-2">
                    Nuova attività
                </button>
            </div>

            <div v-if="sessions.length === 0" class="text-center">
                <p class="lead">Nessuna attività pianificata</p>
            </div>
            <div v-else>
                <h3 class="mb-5">Attività assegnate</h3>

                <div class="col-12 d-flex mb-3" v-for="session in sessions" :key="session.user_structure_session_id">
                    <div class="me-3 display-6 pt-2">
                        <i class="bi bi-check-circle"></i>
                    </div>
                    <div>
                        <a :href="sessionBaseUrl + '&sessionId=' + session.user_structure_session_id">
                            <h4 class="card-title mb-1">
                                <template v-if="session.title">
                                    {{ session.title }}
                                </template>
                                <template v-else>
                                    Attività
                                </template>
                            </h4>
                        </a>
                        <p v-if="session.limitDate">
                            {{ session.date_end | date }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <MbSessionForm ref="adddSessionModal" 
            :userId="parseInt(userId)"
            :type="type"
            :relatedUserId="relatedUserId"
            @reload="load()"></MbSessionForm>
    </div>
</template>
<script>

import MbLoading from '@/components/ui/base/MbLoading.vue'
import axios from 'axios'
import MbSessionForm from './MbSessionForm.vue';

export default {
    components: {
        MbLoading,
        MbSessionForm
    },
    props: {
        userId: Number,
        relatedUserId: Number,
        type: String,
        sessionBaseUrl: String,
        displayNew: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isLoading: true,
            sessions: []
        }
    },
    destroy(){

    },
    mounted() {
        this.load()
    },
    methods: {
        load(){
            this.isLoading = true;
            axios.post('/structure/session/UserSessionAction-getSessionList', {
                    "userId": this.userId,
                    "relatedUserId": this.relatedUserId,
                    "type": this.type,
                })
                .then(response => {
                    this.isLoading = false;
                    this.sessions = response.data
                }).catch(() => {
                    this.isLoading = false;
                });
        },
        onClickNewSession(){
            this.$refs.adddSessionModal.toggle()
        },
    }
}

</script>